import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import {
  setFormValue,
  setStepPages,
  setSteps,
  stepDbPages,
  stepFilePages,
} from "../../../../redux/slices/createdatasetpageslice";
import { FormRadioGroup } from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const SelectOptionForDataset = () => {
  const dispatch = useDispatch();
  const appearance = useSelector((state) => state.appearance);
  const { t } = useTranslation();
  const pageState = useSelector((state) => state.createDatasetPage);

  const fromFileSteps = [
    { label: t("datasets.create.from"), isValid: true },
    { label: t("datasets.create.choosefile"), isValid: undefined },
    { label: t("datasets.create.dataset"), isValid: undefined },
    { label: t("datasets.create.review"), isValid: undefined },
    { label: t("datasets.create.result"), isValid: undefined },
  ];

  const fromDbSteps = [
    { label: t("datasets.create.from"), isValid: true },
    { label: t("datasets.create.fromdb"), isValid: undefined },
    { label: t("datasets.create.choosetable"), isValid: undefined },
    { label: t("datasets.create.dataset"), isValid: undefined },
    { label: t("datasets.create.review"), isValid: undefined },
    { label: t("datasets.create.result"), isValid: undefined },
  ];

  const createDatasetFromList = [
    { label: t("datasets.create.fromdbtable"), value: "fromdb" },
    {
      label: t("datasets.create.fromfile"),
      value: "fromfile",
    },
  ];
  
  const handleOptionChange = (e) => {
    const value = e.value;
    dispatch(setFormValue({ id: "CreateFrom", value }));
    if (value === "fromfile") {
      dispatch(setSteps(fromFileSteps));
      dispatch(setStepPages(stepFilePages));
    } else if (value === "fromdb") {
      dispatch(setSteps(fromDbSteps));
      dispatch(setStepPages(stepDbPages));
    }
  };

  return (
    <FormRegion>
      <div className={`form-group form-group-1 stepper-rd-btns 
        ${
          appearance.isRightToLeft ? "rtl" : "ltr"
        }
      `}>
        <Field
          id={"CreateFrom"}
          name={"CreateFrom"}
          label={t("datasets.create.create")}
          component={FormRadioGroup}
          data={createDatasetFromList}
          value={pageState.formValues.CreateFrom}
          onChange={handleOptionChange}
        />
      </div>
      <style>
        {`
          .datasets-page .stepper-rd-btns #CreateFrom_label{
            font-size:16px;
            font-weight:semi-bold;
            margin-bottom:20px;
          }
            .datasets-page .stepper-rd-btns .k-radio-list li{
            font-size:16px;
            margin-bottom:20px;
          }

          .datasets-page .stepper-rd-btns.rtl .k-radio-list[dir="ltr"] {
            direction: rtl !important;
          }

          .datasets-page .stepper-rd-btns.ltr .k-radio-list[dir="rtl"] {
            direction: ltr !important;
          }
          `}
      </style>
    </FormRegion>
  );
};

export default SelectOptionForDataset;
